import { useCallback } from 'react';

import { useRefinementList } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useSearchPageData } from 'src/app/pages/search/pageContext';
import {
	INSTANT_SEARCH_LOCATION_CITY_FILTER,
	INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER,
} from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<
	undefined,
	{
		filterByNearYou: () => void;
	}
>;

export function useFilterByNearYou(): Result {
	const {
		data: { viewer },
	} = useSearchPageData();
	const track = useTracking();

	const { refine: filterByCountry } = useRefinementList({
		attribute: INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER,
	});

	const { refine: filterByCity } = useRefinementList({
		attribute: INSTANT_SEARCH_LOCATION_CITY_FILTER,
	});

	return {
		actions: {
			filterByNearYou: useCallback(() => {
				void track('search', { q: '', context: 'landing_near_me_button' });

				const city = viewer.user?.city;
				const stateCode = viewer.user?.stateCode;
				const countryCode = viewer.user?.country?.countryCode || viewer.country.countryCode;

				if (city && stateCode) {
					filterByCity(`${city}, ${stateCode}`);
					return;
				}
				if (city) {
					filterByCity(city);
					return;
				}
				if (stateCode) {
					filterByCity(stateCode);
					return;
				}
				filterByCountry(countryCode);
			}, [filterByCity, filterByCountry, track, viewer.country, viewer.user]),
		},
	};
}
